/**
* PendingPage.jsx
* Created by Kevin Li 3/21/16
*/

const PendingPage = () => {
    return (
        <div className="site_wrap usa-da-pending-page">
            <nav className="navbar navbar-default usa-da-header" />
            <div className="site_content pending-page">
                <div className="usa-da-content-dark" />
            </div>
        </div>
    );
};

export default PendingPage;
